import {
    Column,
    Item
} from 'devextreme-react/data-grid';
import { useGetPurchaseOrders } from "../api/get-purchase-orders";
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useState } from 'react';
import { ClosedOrdersControl } from '../../../common';
import { CompanyTypes, MOType } from '../../../../types/enums';
import { useAuth } from '../../../../contexts/auth';

export default function PurchaseOrderGrid() {

    let [closedOrdersState, setClosedOrdersState] = useState<{ closedOrders: boolean, dateFrom: Date | null }>
        ({ closedOrders: false, dateFrom: null });

    const orders = useGetPurchaseOrders(closedOrdersState.closedOrders, closedOrdersState.dateFrom);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    const creditMemoMOTypes = [MOType.Material, MOType.Sink, MOType.Stocking]

    const { user } = useAuth();
    const isManufacturer = user?.companyTypeId === CompanyTypes.MFR;
    const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;
    const urlFolder = isManufacturer ? "manufacturer" : isServiceProvider ? "service-provider" : "distributor";

    return (
        <>
            <SyncDataGrid
                stateStorageKey={urlFolder + '-purchase-order-grid'}
                className={'dx-card wide-card'}
                dataSource={orders.data}
                keyExpr={'purchaseOrderID'}
                height="68vh"
                additionalToolbarItems={[
                    <Item
                        location={'before'}
                        key='closed-orders'
                    >
                        <ClosedOrdersControl
                            onClosedOrdersChanged={(e) => {
                                setClosedOrdersState({ closedOrders: e.checked, dateFrom: e.dateFrom })
                            }}
                        />
                    </Item>
                ]}
            >
                <Column
                    dataField={'poNumber'}
                    caption={'Purchase Order #'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/${urlFolder}/purchase-order/${row.data.purchaseOrderID}?returnUrl=${returnUrl}`}>
                            {row.data.poNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'createdOn'}
                    caption={'Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'roDate'}
                    caption={'Retail Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'cfiName'}
                    caption={'CFI Name'}
                    dataType="string"
                />
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'shipTo'}
                        caption={'Ship To'}
                        dataType="string"
                    />
                }
                <Column
                    dataField={'orderStatus'}
                    caption={'Order Status'}
                    dataType="string"
                />
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'requestedShipDate'}
                        caption={'Requested Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'validatedShipDate'}
                        caption={'Validated Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'actualShipDate'}
                        caption={'Actual Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'requestedDeliveryDate'}
                        caption={'Requested Delivery Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'validatedDeliveryDate'}
                        caption={'Validated Delivery Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'deliveredDate'}
                        caption={'Delivered Date'}
                        dataType="date"
                    />
                }
                {
                    isServiceProvider &&
                    <Column
                        dataField={'serviceInitiatedDate'}
                        caption={'Service Initiated Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'distributorName'}
                        caption={'Distributor'}
                        dataType="string"
                        visible={isManufacturer}
                    />
                }
                <Column
                    dataField={'creditMemo'}
                    caption={'Credit Memo'}
                    dataType="string"
                    allowExporting={false}
                    cellRender={(row: any) => {

                        if ((!!row.data.actualShipDate || !!row.data.serviceInitiatedDate) &&
                            (creditMemoMOTypes.includes(row.data.moTypeID) || isServiceProvider)) {
                            return <Link to={`/${urlFolder}/credit-memo/${row.data.purchaseOrderID}/new?returnUrl=${returnUrl}`}>
                                Credit Memo
                            </Link>;
                        }
                        else {
                            return <></>
                        }
                    }}
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
